import { useCallback } from "react";
import { useQuery } from "react-query";
import { getUser, ReferralApi } from "@jti/rest-api";
import { setLoyaltyReminder, useDispatch } from "@jti/store";
export const useLoyaltyCustomerState = () => {
    const dispatch = useDispatch();
    const { uuid = "", ciam_token = "" } = getUser();
    const syncLoyaltyCustomerState = useCallback((data) => {
        dispatch(setLoyaltyReminder({
            hasFirstPurchase: Boolean(data.has_first_purchase),
            parentCodeExists: Boolean(data.parent_code),
        }));
    }, [dispatch]);
    return useQuery("ReferralApi.getCustomer", () => ReferralApi.init().getCustomer(uuid, ciam_token), {
        enabled: Boolean(uuid && ciam_token),
        onSuccess: syncLoyaltyCustomerState,
    });
};
//# sourceMappingURL=useLoyaltyCustomerState.js.map